import get from 'lodash/get';
import { event } from '@uhg-abyss/web/tools/event';

export const searchEvent = (data) => {
  const eventData = event.getData();
  const searchEventTrigger = get(data, 'searchEventTrigger');
  const searchTerm = get(data, 'searchTerm');
  return {
    coveoSearch: {
      ...eventData.coveoSearch,
      searchEventTrigger: searchEventTrigger || 'searchBoxSubmit',
      searchTerm,
      searchFacetValues: [],
      searchSort: 'relevancy',
      searchStartIndex: 0,
      searchPagination: 1,
    },
  };
};

export const facetChangeEvent = (data) => {
  const eventData = event.getData();
  const searchEventTrigger = get(data, 'searchEventTrigger');
  const searchFacetValues = get(data, 'searchFacetValues');

  return {
    coveoSearch: {
      ...eventData.coveoSearch,
      searchFacetValues,
      searchEventTrigger,
      searchPagination: 1,
    },
  };
};

export const sortChangeEvent = (data) => {
  const eventData = event.getData();
  const searchSort = get(data, 'searchSort');
  const searchEventTrigger = get(data, 'searchEventTrigger');

  return {
    coveoSearch: {
      ...eventData.coveoSearch,
      searchSort,
      searchEventTrigger,
      searchPagination: 1,
    },
  };
};

export const pagerNumberEvent = (data) => {
  const eventData = event.getData();
  const searchEventTrigger = get(data, 'searchEventTrigger');
  const searchPagination = get(data, 'searchPagination');

  return {
    coveoSearch: {
      ...eventData.coveoSearch,
      searchEventTrigger,
      searchPagination,
    },
  };
};

export const resultsCountEvent = (data) => {
  const eventData = event.getData();
  const searchResults = get(data, 'totalCountFiltered');

  return {
    coveoSearch: {
      ...eventData.coveoSearch,
      searchResults,
    },
  };
};

export const resultsPerPageEvent = (data) => {
  const eventData = event.getData();
  const searchItemsPerPage = get(data, 'searchItemsPerPage');
  const searchEventTrigger = get(data, 'searchEventTrigger');

  return {
    coveoSearch: {
      ...eventData.coveoSearch,
      searchItemsPerPage,
      searchEventTrigger,
    },
  };
};

export const searchCompleteEvent = (data) => {
  const eventData = event.getData();
  const searchStartIndex = get(data, 'searchStartIndex');
  const searchItemsPerPage = get(data, 'searchItemsPerPage');

  return {
    coveoSearch: {
      ...eventData.coveoSearch,
      searchStartIndex,
      searchItemsPerPage,
    },
  };
};
